import type { Template } from '@lark-automadoc/shared-types'

/**
 * Determine if a template is ready or needs setup.
 * A template is ready when it has both a file uploaded (r2_key) and a valid owner.
 */
export function getTemplateStatus(template: Pick<Template, 'r2_key' | 'owner_name'>): 'ready' | 'setup-required' {
  return template.r2_key && template.owner_name ? 'ready' : 'setup-required'
}
